import { render, staticRenderFns } from "./serveOrderList.vue?vue&type=template&id=38667494&scoped=true&"
import script from "./serveOrderList.vue?vue&type=script&lang=js&"
export * from "./serveOrderList.vue?vue&type=script&lang=js&"
import style0 from "./serveOrderList.vue?vue&type=style&index=0&id=38667494&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38667494",
  null
  
)

export default component.exports